import { gameRepository } from "../../storage/storage";
import { BoxscoreService } from "./boxscore-service";
import TennisStatsService from "../tennis-stats-service";

class TennisBoxscoreService extends BoxscoreService {
    async serialize(eventId) {
        const game = await gameRepository.where({ eventId: eventId }).first();
        const { boxscore } = await TennisStatsService.getBoxScore(game.id);

        return boxscore;
    }
}

export default new TennisBoxscoreService();
